{
  "invalidSelection": "所選的{selectedCount, plural, one {日期} other {日期}}無法使用。"
}
